import { FC } from 'react'

import { Stack } from '@mui/material'
import { AutoCompleteOption } from '@/components/inputs/LicenseCompetitionsAutocomplete/LicenseCompetitionsAutocomplete'

import { AvailableCompetitionsSection } from './AvailableCompetitionsSection'
import { EmptyCompetitionsState } from './EmptyCompetitionsState'
import { LoadingCompetitionsState } from './LoadingCompetitionsState'
import { SelectedCompetitionsSection } from './SelectedCompetitionsSection'

type CompetitionsListProps = {
  isLoading: boolean
  debouncedSearchQuery: string
  hasMissingIds: boolean
  isAutoLoading: boolean
  competitions: AutoCompleteOption[]
  selectedCompetitionsList: AutoCompleteOption[]
  unselectedCompetitionsList: AutoCompleteOption[]
  selectedCompetitionIds: string[]
  onCompetitionToggle: (competition: AutoCompleteOption) => void
  hasMore: boolean
  isLoadingMore: boolean
  currentPage: number
  loadMore: (page: number) => void
}

export const CompetitionsList: FC<CompetitionsListProps> = ({
  isLoading,
  debouncedSearchQuery,
  hasMissingIds,
  isAutoLoading,
  competitions,
  selectedCompetitionsList,
  unselectedCompetitionsList,
  selectedCompetitionIds,
  onCompetitionToggle,
  hasMore,
  isLoadingMore,
  currentPage,
  loadMore
}) => {
  return (
    <Stack
      sx={{
        flex: 1,
        borderRadius: 1,
        overflow: 'hidden'
      }}
    >
      {(isLoading && !debouncedSearchQuery) || (hasMissingIds && isAutoLoading) ? (
        <LoadingCompetitionsState isAutoLoading={isAutoLoading} />
      ) : !competitions || !competitions.length ? (
        <EmptyCompetitionsState />
      ) : (
        <Stack gap={2}>
          <SelectedCompetitionsSection
            selectedCompetitionsList={selectedCompetitionsList}
            selectedCompetitionIds={selectedCompetitionIds}
            onCompetitionToggle={onCompetitionToggle}
            debouncedSearchQuery={debouncedSearchQuery}
          />

          <AvailableCompetitionsSection
            unselectedCompetitionsList={unselectedCompetitionsList}
            selectedCompetitionIds={selectedCompetitionIds}
            onCompetitionToggle={onCompetitionToggle}
            debouncedSearchQuery={debouncedSearchQuery}
            isLoading={isLoading}
            hasMore={hasMore}
            isLoadingMore={isLoadingMore}
            isAutoLoading={isAutoLoading}
            currentPage={currentPage}
            loadMore={loadMore}
            selectedCompetitionsListLength={selectedCompetitionsList.length}
          />
        </Stack>
      )}
    </Stack>
  )
}
